<script>
import api from "@/axios";
import Loader from "../components/loader";
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import 'vue3-lottie/dist/style.css'
import exportFromJSON from "export-from-json"
import useVuelidate from "@vuelidate/core";
import {helpers, required} from "@vuelidate/validators";
import moment from "moment/moment";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Estados",
    meta: [{ descricao: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, Loader },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      // AstronautJSON,

      title: 'Estados',
      items: [
        {
          text: 'Fiscal',
          href: '/',
        },
        {
          text: 'Estados',
          active: true,
        },
      ],
      errosValid: null,
      loadingList: true,
      loadingGraph: true,
      estadosList: null,

      pesqTextFilter: '',
      statusFilter: 'T',
      regSelecionado: {},
      submitted: false,
      showModal: false,
      sortBy: 'id',
      sortDesc: true,

      validations: {
        regSelecionado :{
          descricao: {
            required: helpers.withMessage("Campo descrição obrigatório, favor preencher.", required),
          },
          status: {
            required: helpers.withMessage("Campo status obrigatório, favor preencher.", required),
          },
          sigla: {
            required: helpers.withMessage("Campo código obrigatório, favor preencher.", required),
          },
        }
      },

    }
  },
  methods: {
    exportExcel(){
      console.log('exportExcel')
      const data = this.estadosList
      const fileName = "exp_dados";
      const exportType = exportFromJSON.types.xls;
      if (data) exportFromJSON({ data, fileName, exportType });
    },

    atualizaDataList(){
      this.loadingList = true

      api.get(`${getBaseUrl()}api/estados`, {
        params: {
          'q': this.pesqTextFilter,
          's': this.statusFilter,
          'o': this.sortBy,
          'od': this.sortDesc
        }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)

        if (res.data.error){
          console.log(res.data.error)
          this.$router.push(`/faltapermissao`);
        }else{
          this.estadosList = res.data[0]
          this.title = `(${this.estadosList.length}) Estados`
          this.loadingList = false
          this.loadingGraph = false
        }
      });
    },

    deletouReg(dataID){
      console.log('deletouReg_pai dataid:')
      console.log(dataID)
      this.estadosList = null
      this.loadingList = true
      api.delete(`${getBaseUrl()}api/estado`, {
        params: {
          'iddata': dataID
        }
      }).then((res) => {
        console.log('then axios delete')
        console.log(res.data)
        this.atualizaDataList()
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações excluídas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })
      })
    },

    alterouReg(regSelecionado) {
      console.log('alterouReg_pai')
      console.log(regSelecionado)
      this.estadosList = null
      this.loadingList = true
      this.errosValid = []
      api.post(`${getBaseUrl()}api/estado`, {
        estadoData: regSelecionado
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        // this.produtoData = res.data[0]
        this.loadingList = false

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações salvas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })

      }).catch((err) => {
        console.log('erro axios')
        // console.log(err)
        // console.log(err.response)
        // console.log(err.response.data.errors)
        let erros = err.response.data.errors
        console.log(erros)
        console.log(typeof  erros)
        let listaErros = []
        Object.keys(erros).forEach(key => {
          console.log(key, erros[key]);
          listaErros.push({
            'titulo': key,
            'mensagem': erros[key]
          })
        });
        this.errosValid = listaErros

      }).finally(()=>{
        this.atualizaDataList()
      })
    },

    // criarNova() {
    //   console.log('criarNova')
    //   this.$refs.childTable.setCriarNova(true)
    //
    // },

    ordenar(field) {
      console.log('sortBy')
      console.log(field)
      if (field === this.sortBy){
        this.sortDesc = !this.sortDesc
      }
      this.sortBy = field
      this.atualizaDataList()


    },

    nomeStatus(strEntr){
      let result = 'Não Definido'
      switch (strEntr) {
        case 'A':
          result = 'Ativo'
          break
        default:
          result = 'Inativo'
          break
      }
      return result
    },

    editar(dataID){
      console.log('editar: ' + dataID)
      this.showModal = true
      this.regSelecionado = this.estadosList.find((reg) => reg.id === dataID);
      console.log('regSelecionado: ')
      console.log(this.regSelecionado)
    },

    deletar(dataID){
      console.log('deletar: ' + dataID)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {

        if (result.value) {
          this.deletouReg(dataID)
        }
      })
    },

    formSubmit() {
      console.log('formSubmit_0')
      this.submitted = true
      this.v$.$touch()
      if (this.v$.$invalid) {
        return;
      } else {
        console.log('formSubmit_validado')
        this.showModal = false
        this.alterouReg( this.regSelecionado)
      }
    },

    setCriarNova: function() {
      this.regSelecionado = {}
      this.submitted = false
      this.showModal = true
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

  },
  mounted() {
    console.log('mounted estados-list_0')
    this.atualizaDataList()
  },
}
</script>

<template>

  <Layout>


    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">

              <div class="col-sm-2">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <input
                        id="inputPesquisa"
                        type="text"
                        v-model="pesqTextFilter"
                        class="form-control"
                        placeholder="Enter para pesquisar..."
                        @change="atualizaDataList"/>
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>

              <div class="col-sm-1">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <select
                        id="selectStatus"
                        v-model="statusFilter"
                        @change="atualizaDataList"
                        class="form-control select2-search-disable">
                      <option value="T" selected>Todos</option>
                      <option value="A">Ativos</option>
                      <option value="I">Inativos</option>
                    </select>
                    <i class="bx bx-filter-alt search-icon"></i>
                  </div>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="mb-2 d-inline-block">
                  <div class="position-relative">
                    <b-button variant="outline-primary" class="" @click="exportExcel">
                      <i class="bx bx-export font-size-16 align-middle "></i>
                    </b-button>
                  </div>
                </div>
              </div>

              <div class="col-sm-7">
                <div class="text-sm-end">
                  <button type="button" class="btn btn-success btn-rounded mb-2 me-2" @click="setCriarNova">
                    <i class="mdi mdi-plus me-1"></i> Novo Estado
                  </button>
                </div>
              </div>
            </div>

            <Loader v-if="loadingList" style="min-height: 300px;">
            </Loader>

            <div class="table-responsive mb-0">
              <table class="table align-middle table-nowrap table-striped table-hover"  v-if="estadosList">
                <thead class="table-light">
                <tr>

                  <th class="align-middle">
                    <a href="javascript: void(0);" @click="ordenar('id')" aria-label="Ordenar">
                      ID
                    </a>
                  </th>
                  <th class="align-middle">
                    <a href="javascript: void(0);" @click="ordenar('codigo')" aria-label="Ordenar">
                      Código
                    </a>
                  </th>
                  <th class="align-middle">
                    <a href="javascript: void(0);" @click="ordenar('descricao')" aria-label="Ordenar">
                      Descrição
                    </a>
                  </th>
                  <th class="align-middle">
                    <a href="javascript: void(0);" @click="ordenar('sigla')" aria-label="Ordenar">
                      Sigla
                    </a>
                  </th>

                  <th class="align-middle text-end">Alíquota ICMS</th>
                  <th class="align-middle">Data</th>
                  <th class="align-middle">Status</th>
                  <th class="align-middle">Ações</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in estadosList" :key="data.id">
                  <td>
                    <a href="javascript: void(0);"
                       class="text-body fw-bold"
                       @click="editar(data.id)">{{ data.id }}
                    </a>
                  </td>
                  <td>{{ data.codigo }} </td>
                  <td>{{ data.descricao }} </td>
                  <td>{{ data.sigla }} </td>
                  <td class="text-end">{{ formatDecimal(data.aliqicms) }} </td>
                  <td>{{ formatDateTime(data.created_at) }} </td>

                  <td>
              <span
                  class="badge badge-pill badge-soft-success font-size-11"
                  :class="data.status === 'A' ? 'badge-soft-success' : 'badge-soft-danger'">
                {{ nomeStatus(data.status)  }}
              </span>
                  </td>

                  <td>
                    <div class="button-items">
                      <b-button variant="outline-success" @click="editar(data.id)">
                        <i class="mdi mdi-pencil d-block font-size-16"></i>
                      </b-button>
                      <b-button variant="outline-danger" @click="deletar(data.id)">
                        <i class="mdi mdi-trash-can d-block font-size-16"></i>
                      </b-button>
                    </div>
                  </td>

                </tr>
                </tbody>
              </table>

              <b-modal :title="regSelecionado.id != null ? `Editar Estado (${ regSelecionado.id })` : 'Criar Novo Estado'" v-model="showModal" hide-footer>
                <form @submit.prevent="formSubmit">
                  <div class="row">

                    <div class="col-12">
                      <div class="mb-3">
                        <label for="descricao">Descrição</label>
                        <input
                            id="descricao"
                            v-model="regSelecionado.descricao"
                            type="text"
                            class="form-control"
                            placeholder="Inserir descrição"
                            :class="{'is-invalid': submitted && v$.regSelecionado.descricao.$error,}"/>
                        <div
                            v-if="submitted && v$.regSelecionado.descricao.$error"
                            class="invalid-feedback">
                            <span v-if="v$.regSelecionado.descricao.required.$message">
                              {{ v$.regSelecionado.descricao.required.$message }}
                            </span>
                        </div>
                      </div>
                    </div>

                    <div class="col-6">
                      <div class="mb-3">
                        <label for="codigo">Código</label>
                        <input
                            id="codigo"
                            v-model="regSelecionado.codigo"
                            type="text"
                            class="form-control"
                            placeholder="Inserir código"/>
                      </div>
                    </div>

                    <div class="col-6">
                      <div class="mb-3">
                        <label for="sigla">Sigla</label>
                        <input
                            id="sigla"
                            v-model="regSelecionado.sigla"
                            type="text"
                            class="form-control"
                            placeholder="Inserir sigla"
                            :class="{'is-invalid': submitted && v$.regSelecionado.sigla.$error,}"/>
                        <div
                            v-if="submitted && v$.regSelecionado.sigla.$error"
                            class="invalid-feedback">
                            <span v-if="v$.regSelecionado.sigla.required.$message">
                              {{ v$.regSelecionado.sigla.required.$message }}
                            </span>
                        </div>
                      </div>
                    </div>



                    <div class="col-6">
                      <div class="mb-3">
                        <label for="selectStatus">Status</label>
                        <b-form-select
                            id="selectStatus"
                            v-model="regSelecionado.status"
                            class="mb-3 form-select form-control"
                            :class="{'is-invalid': submitted && v$.regSelecionado.status.$error,}">
                          <b-form-select-option value="A">
                            Ativo
                          </b-form-select-option>
                          <b-form-select-option value="I">
                            Inativo
                          </b-form-select-option>
                          <b-form-select-option value="L">
                            Análise
                          </b-form-select-option>
                        </b-form-select>
                        <div v-if="submitted && v$.regSelecionado.status.$error" class="invalid-feedback">
                        <span v-if="v$.regSelecionado.status.required.$message">
                          {{ v$.regSelecionado.status.required.$message }}
                        </span>
                        </div>

                      </div>
                    </div>

                    <div class="col-6">
                      <div class="mb-3">
                        <label for="aliqicms">Alíquota ICMS</label>
                        <input
                            id="aliqicms"
                            v-model="regSelecionado.aliqicms"
                            type="number"
                            class="form-control"
                            placeholder="Alíquota ICMS"/>
                      </div>
                    </div>


                  </div>

                  <div class="text-end mt-3">
                    <b-button variant="light" @click="showModal = false">
                      <i class="bx bx-block font-size-16 align-middle me-2"></i>
                      Fechar
                    </b-button>
                    <b-button variant="success" class="ms-1" @click="formSubmit">
                      <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
                      Confirmar
                    </b-button>
                  </div>

                </form>

              </b-modal>
            </div>

<!--            <EstadosTable-->
<!--                ref="childTable"-->
<!--                :estadosList="estadosList"-->
<!--                @deletareg="deletouReg"-->
<!--                @alterareg="alterouReg"/>-->


<!--            <ul class="pagination pagination-rounded justify-content-end mb-2">-->
<!--              <li class="page-item disabled">-->
<!--                <a class="page-link" href="javascript: void(0);" aria-label="Previous">-->
<!--                  <i class="mdi mdi-chevron-left"></i>-->
<!--                </a>-->
<!--              </li>-->
<!--              <li class="page-item active">-->
<!--                <a class="page-link" href="javascript: void(0);">1</a>-->
<!--              </li>-->

<!--              <li class="page-item disabled">-->
<!--                <a class="page-link" href="javascript: void(0);" aria-label="Next">-->
<!--                  <i class="mdi mdi-chevron-right"></i>-->
<!--                </a>-->
<!--              </li>-->
<!--            </ul>-->


          </div>

        </div>
      </div>
    </div>

    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>

    <Loader v-if="loadingGraph" style="min-height: 300px;">
    </Loader>


  </Layout>
</template>
